type SvgProps = React.SVGProps<SVGSVGElement>;
export const Payroll = (props: SvgProps) => {
  return (
    <svg
      {...props}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1351 14.1042C17.1351 15.1595 16.1536 16.0182 14.9476 16.0182V16.6562H13.4893V16.0182C12.2832 16.0182 11.3018 15.1595 11.3018 14.1042H12.7601C12.7601 14.4557 13.0868 14.7422 13.4893 14.7422H14.9476C15.3501 14.7422 15.6768 14.4557 15.6768 14.1042C15.6768 13.863 15.4792 13.6588 15.2072 13.6193L12.9898 13.2958C12.0112 13.1535 11.3018 12.4198 11.3018 11.5521C11.3018 10.4968 12.2832 9.63802 13.4893 9.63802V9H14.9476V9.63802C16.1536 9.63802 17.1351 10.4968 17.1351 11.5521H15.6768C15.6768 11.2005 15.3501 10.9141 14.9476 10.9141H13.4893C13.0868 10.9141 12.7601 11.2005 12.7601 11.5521C12.7601 11.7933 12.9577 11.9974 13.2297 12.037L15.4471 12.3605C16.4256 12.5027 17.1351 13.2365 17.1351 14.1042ZM9.91707 10.9141C10.0279 10.44 10.2685 10.0106 10.5908 9.63802H3.28092V14.1042H9.84342V12.8281H4.73926V10.9141H9.91707ZM3.28092 8.36198H6.92676V7.08594H3.28092V8.36198ZM6.92676 4.53385H3.28092V5.8099H6.92676V4.53385ZM11.3244 16.6562H0.364258V3.25781C0.364258 2.20253 1.34572 1.34375 2.55176 1.34375H9.41613L14.9476 6.18378V7.72396H13.4893V7.08594H8.38509V2.61979H2.55176C2.14999 2.61979 1.82259 2.90626 1.82259 3.25781V15.3802H10.1526C10.4093 15.8913 10.8183 16.3264 11.3244 16.6562ZM9.84342 5.8099H12.4582L9.84342 3.52195V5.8099Z"
        fill="currentColor"
      />
    </svg>
  );
};
